
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/quick-meet/[quickMeetId]/edit",
      function () {
        return require("private-next-pages/admin/quick-meet/[quickMeetId]/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/quick-meet/[quickMeetId]/edit"])
      });
    }
  